import Vue from "vue";
import Component from "vue-class-component";
import ABaseComponent from 'Components/Base/ABaseComponent';
import { Client, CreatePorterItemCommandArguments, PorterViewModel, ProductViewModel, PorterKey } from "Api/CoreApi";
import { Prop } from "vue-property-decorator";
import { UpdateCartEvent } from "Events/Events";
import { TypedEvent } from "Events/TypedEvent";
import { State, Getter, Action } from 'vuex-class';
import { PorterBuilderState } from "Store/types";
import ApiProvider from "Api/ApiProvider";
import { forEach } from "lodash-es";

@Component({
    template: "#add-to-porter-modal-template"
})
export default class AddToPorterModalComponent extends ABaseComponent {
    
    @Prop()
    public modalId: string;
    @Prop()
    public productId: string;
    @Prop()
    public productName: string;
    @Prop()
    public languageId: string;

    @State("porterBuilder")
    private porterBuilder: PorterBuilderState;
    
    public productVariants: { [itemNo: string]: string } = {};
    public porterVariantsList: string[] = [];
    public porterList: PorterViewModel[] = null;

    public productVariantsCount: number = 0;
    public selectedPorterId: string = "";
    public selectedVariantId: string = "";
    public comment: string = "";
    public showWarning: boolean = false;
    public saved: boolean = false;
    static updateCartEvent: TypedEvent<UpdateCartEvent> = new TypedEvent<UpdateCartEvent>();
    public shouldRequestData: boolean = true;

    async load() {
        this.setLoading();

        // Get list of porters
        const client = ApiProvider.getApiClient();
        client.getPorterList()
            .then(result => {
                this.porterList = result.porters;
            });

        // Get variants of current product
        client.getProductVariantsById(this.languageId, this.productId)
            .then(result => {
                for (let i = 0; i < result.productVariants.length; i++) {
                    this.productVariants[result.productVariants[i].itemNumber] = result.productVariants[i].basicMetrics.Size;
                }
                this.productVariantsCount = result.productVariants.length;
            });
        this.setLoaded();
        this.shouldRequestData = false;
    }

    async loadVariants() {
        // If modal was not loaded before, then request data from API
        if(this.shouldRequestData) {
            await this.load();
        }
    }

    mounted() {
        this.$root.$on('loadProductVariants', (modalId: string) => {
            if (modalId == this.modalId) {
                this.loadVariants();
            }
        });
    }

    async addProductToPorter() {
        this.setLoading();
        try {
            const args = new CreatePorterItemCommandArguments({
                porterKey: new PorterKey({
                    id: this.selectedPorterId
                }),
                comment: this.comment,
                itemNo: this.selectedVariantId
            });
            const client = ApiProvider.getApiClient();
            client.createPorterItem(args).then(result => {
                AddToPorterModalComponent.updateCartEvent.emit(UpdateCartEvent);
                this.setLoaded();
                this.saved = true;
            });
        } catch (e) {
            this.setError(e);
        }
    }
    async resetSaved() {
        this.saved = false;
    }

    async evaluateListForPorter() {
         //Get list of porter variants of the product
        const client = ApiProvider.getApiClient();
        client.getPorterItems(this.languageId, this.selectedPorterId)
            .then(result => {
                var porterVariants: string[] = [];
                result.porterItems.forEach((item) => {
                    if (item.product.productId == this.productId) {
                        porterVariants.push(item.product.itemNumber);
                    }
                });
                this.porterVariantsList = porterVariants;
            });
        this.resetSaved();
    }
    async validateVariant() {
        const client = ApiProvider.getApiClient();
        client.getPorterItems(this.languageId, this.selectedPorterId)
            .then(result => {
                var porterVariants: string[] = [];
                result.porterItems.forEach((item) => {
                    if (item.product.productId == this.productId) {
                        porterVariants.push(item.product.itemNumber);
                    }
                });
                this.porterVariantsList = porterVariants;
                this.showWarning = this.porterVariantsList.indexOf(this.selectedVariantId) > -1;
                
            });
        this.resetSaved();
    }
}

Vue.component('add-to-porter-modal', AddToPorterModalComponent);